import BenchlingConfig from 'BenchlingConfig';

/**
 * Whether certain features related to AA parts are enabled for a tenant because they either have AA parts
 * or antibody chains enabled.
 */
export function areAaPartFeaturesEnabledForAntibody(): boolean {
  return BenchlingConfig.MOLBIO_ENABLE_AA_PARTS || BenchlingConfig.MOLBIO_ENABLE_ANTIBODY_CHAINS;
}
